import axios from "axios";

export const apiURL = process.env.REACT_APP_API_URL + "api";

export const customFetch = axios.create({
  baseURL: apiURL,
  // You can add default headers or other axios options here
});

// export const refreshTokenInterceptor = (handleNewToken, handleLogout) => {

// };

// const accessTokenInterceptor = (user)=> {
//   customFetch.interceptors.request.use(
//     (config) => {
//       if (user?.accessToken) {
//         config.headers[
//           "Authorization"
//         ] = `Bearer ${user?.accessToken}`;
//       }
//       return config;
//     },
//     (error) => Promise.reject(error)
//   );
// }

// Generic API request function that handles any request method.
export const apiRequest = async (method, url, data = null, options = {}) => {
  try {
    const response = await customFetch.request({
      method,
      url,
      data,
      ...options,
    });
    return response;
  } catch (error) {
    // console.error("API request error:", error);
    throw error;
  }
};

// Convenience wrappers
export const getAPI = (url, options) => apiRequest("GET", url, null, options);
export const postAPI = (url, data, options) =>
  apiRequest("POST", url, data, options);
export const putAPI = (url, data, options) =>
  apiRequest("PUT", url, data, options);
export const deleteAPI = (url, options) =>
  apiRequest("DELETE", url, null, options);
